import React from 'react';
import { Link } from 'react-router-dom';

const cardStyle = {
  backgroundColor: 'var(--card-bg)',
  border: '1px solid var(--card-border)',
};

// Thumbnail-led video card: 16:9 image, then title, creator and duration.
// Shared by the Explore video-library grid and the Explore discovery strip, so
// a video looks the same in both. The compact horizontal row lives in
// VideoListItem — that one suits a narrow sidebar, this one suits a grid where
// the thumbnail is meant to carry visual weight.
//
// A missing thumbnail leaves the plate empty rather than showing a broken-image
// icon; duration and the Staff Pick flag only render when present, so nothing
// is fabricated to fill the frame.
const VideoPreviewCard = ({ video }) => (
  <Link
    to={`/video/${video.id}`}
    className="block rounded-xl overflow-hidden cursor-pointer transition-all duration-300 hover:-translate-y-0.5 active:scale-[0.98]"
    style={cardStyle}
  >
    <div className="relative aspect-video" style={{ backgroundColor: 'var(--pill-bg)' }}>
      {video.thumbnail && (
        <img
          src={video.thumbnail}
          alt={video.title}
          className="w-full h-full object-cover"
          loading="lazy"
        />
      )}
      {video.duration && (
        <div className="absolute bottom-1 right-1 bg-black/70 text-white text-xs px-1.5 py-0.5 rounded">
          {video.duration}
        </div>
      )}
      {video.isCurated && (
        <div className="absolute top-1.5 right-1.5 pointer-events-none">
          <span
            className="px-1.5 py-0.5 rounded-full text-xs font-semibold text-white"
            style={{ backgroundColor: 'var(--brand-primary)', backdropFilter: 'blur(8px)' }}
          >
            Staff Pick
          </span>
        </div>
      )}
    </div>
    <div className="p-2.5">
      <h3 className="text-xs font-semibold text-primary leading-tight line-clamp-2">{video.title}</h3>
      {/* views is null for every real source — only mock rows carry it. */}
      {(video.creator || video.views != null) && (
        <p className="text-xs text-tertiary mt-1 truncate">
          {video.creator}{video.views != null ? ` · ${video.views}` : ''}
        </p>
      )}
    </div>
  </Link>
);

export default VideoPreviewCard;
